export enum OptionType {
  ACCESSORY = 'Accessories',
  PACK = 'Accessories pack',
  SERVICE_PLAN = 'Service Plan',
}
